import React, { useEffect, useState } from 'react';
import { getCategoryCharacteristics } from '../../../api/getCategoryCharacteristics';

function CharacteristicsDisplay({ categoryId, jsonData }) {
    const [characteristics, setCharacteristics] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!categoryId) return;
        setLoading(true);
        getCategoryCharacteristics(categoryId)
            .then(setCharacteristics)
            .finally(() => setLoading(false));
    }, [categoryId]);

    if (loading) {
        return (
            <div className="bg-white rounded-[10px] p-5 mt-3 animate-pulse">
                <div className="h-4 bg-gray-200 rounded w-1/3 mb-4" />
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="flex justify-between py-2.5 border-b border-gray-100">
                        <div className="h-3 bg-gray-200 rounded w-1/3" />
                        <div className="h-3 bg-gray-200 rounded w-1/4" />
                    </div>
                ))}
            </div>
        );
    }

    if (!characteristics.length) return null;

    const data = jsonData && typeof jsonData === 'object' ? jsonData : {};

    // Кем дегенде бір толтырылған мән болса ғана көрсет
    const hasAnyValue = characteristics.some(c => {
        const v = data[c.field_label];
        return v !== null && v !== undefined && String(v).trim() !== '';
    });

    if (!hasAnyValue) return null;

    return (
        <div className="bg-white rounded-[10px] p-5 mt-3">
            {/* Header */}
            <div className="flex items-center gap-2 mb-4">
                <div className="w-1 h-5 bg-[var(--primary-color)] rounded-full flex-shrink-0" />
                <h3 className="text-base font-bold text-gray-900 m-0">Сипаттамалар</h3>
            </div>

            {/* Rows */}
            <div className="divide-y divide-gray-100">
                {characteristics.map((char) => {
                    const value = data[char.field_label];
                    const hasValue = value !== null && value !== undefined && String(value).trim() !== '';
                    return (
                        <div key={char.id} className="flex items-center justify-between py-2.5 gap-4">
                            <span className="text-sm text-gray-500 shrink-0 w-1/2">{char.field_label}</span>
                            <span className={`text-sm font-semibold text-right ${hasValue ? 'text-gray-900' : 'text-gray-300'}`}>
                                {hasValue ? String(value) : '—'}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default CharacteristicsDisplay;
